import { render, staticRenderFns } from "./BulkTransferInComponent.vue?vue&type=template&id=416e855f&"
import script from "./BulkTransferInComponent.vue?vue&type=script&lang=js&"
export * from "./BulkTransferInComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports